<template>
  <div
    class="form-text control-group"
    :class="{ error: error }"
  >
    <label
      class="control-label"
      :for="name"
    >
      <abbr
        v-if="required"
        title="Verplicht veld"
      >
        *
      </abbr>
      {{ label }}
    </label>
    <div class="form-builder__options">
      <input
        :id="name"
        type="text"
        :placeholder="environment !== 'registration-pdf' ? placeholder : ''"
        :value="value"
        @input="$emit('input', $event.target.value)"
      >
    </div>
    <span
      v-if="error && error.input"
      class="help-inline"
    >
      {{ error.input }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'FormText',

  schema: [
    {
      name: 'label',
      default: 'Label',
      type: 'FormText',
      label: 'Label',
    },
    {
      name: 'placeholder',
      default: 'Uitleg',
      type: 'formText',
      label: 'Placeholder',
    },
    {
      name: 'required',
      default: false,
      type: 'FormCheckbox',
      label: 'Verplicht',
    },
  ],

  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object,
      default: () => (null),
    },
    environment: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.form-text {
  display: flex;
  flex-grow: 1;

  label.control-label {
    width: 50%;
    font-size: 14px;
    line-height: 30px;
    margin-right: 20px;
    padding-left: 40px;
    text-align: left;
  }

  .form-builder__options {
    width: 50%;
    // margin-right: 10px;


    input {
      width: -webkit-fill-available;
    }
  }
}
</style>
